<script lang="ts">
	import { page } from '$app/stores';
	import Button from '$lib/components/Button/Button.svelte';
	import { classes } from '$lib/utils';
	import BgPlayerGuardOverlay from './BgPlayerGuardOverlay.svelte';
	import { getTranslate } from '@tolgee/svelte';
	const { t } = getTranslate();

	export let additionalClass = '';
</script>

<div
	class={classes(
		'absolute h-full w-full flex justify-center items-center bg-purple-700',
		additionalClass
	)}
>
	<BgPlayerGuardOverlay />
	<div class="p-6 pt-12 lg:pt-6 grid grid-cols-12 z-0" on:click on:keypress>
		<h4
			class="mb-2 uppercase col-start-2 col-end-11 lg:col-end-9 font-bold md:font-normal text-sm md:text-3xl lg:text-4xl xl:text-5xl"
		>
			{$t('PlayerGuardOverlay.headline')}
		</h4>
		<p
			class="mb-4 lg:mb-12 font-normal col-start-2 col-end-11 lg:col-end-9 text-sm md:text-md lg:text-lg font-regular"
		>
			{$t('PlayerGuardOverlay.subline')}
		</p>
		<div class="flex -ml-6 md:ml-0 gap-6 col-start-2 col-end-11 lg:col-end-9 justify-start">
			<a href="/auth/signup?redirect={$page.url}" class="mb-4">
				<Button additionalClass="!px-8 lg:!px-16 !py-1 lg:!py-2 whitespace-nowrap" on:keypress
					>{$t('PlayerGuardOverlay.button.signup')}</Button
				>
			</a>

			<a href="/auth/login?redirect={$page.url}">
				<Button
					additionalClass="!px-8 lg:!px-16 !py-1 lg:!py-2 whitespace-nowrap"
					design="white"
					on:keypress>{$t('PlayerGuardOverlay.button.login')}</Button
				>
			</a>
		</div>
	</div>
</div>
